import React, { useEffect, useRef } from "react";
import { IKImage } from "imagekitio-react";
import { useState } from "react";
import { nextSubscription, getDayDecor } from "../../../utils/subscription";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getLeads } from "../../../redux/actions/userSubscription";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  checkEligibity,
  createLeadScore,
} from "../../../redux/actions/pricing";
import {
  faClipboardCheck,
  faClipboardList,
} from "@fortawesome/free-solid-svg-icons";
import Constants, {
  leadScoringActivity,
  userActivity,
} from "../../../common/constants";
import { Mixpanel } from "../../../config/Mixpanel";
import ReactPixel from "react-facebook-pixel";
import { addUserActivity } from "../../../redux/actions/profileDetails";

const PricingCard = ({
  cardData,
  id,
  activePricingId,
  isCardEnabled,
  setIsCardEnabled,
  section,
  scrollToMax,
  isSelected,
  setIsSelected,
}) => {
  const user_id = useSelector((store) => store?.profileDetails?.id);

  const dispatch = useDispatch();

  const email = useSelector((store) => store?.profileDetails?.email);

  const scrollRef = useRef();
  const [searchParams, setSearchParams] = useSearchParams();
  const user_role = useSelector((store) => store?.userSubscription?.user_role);
  const isBlocked = useSelector(
    (store) => store?.userActivity?.user_trial_blocked,
  );

  useEffect(() => {
    if (parseInt(section) === id || scrollToMax === id) {
      console.log("insidr");
      if (scrollRef?.current) {
        scrollRef?.current?.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [searchParams.get("section"), scrollToMax]);

  function createLeads(metadata) {
    switch (metadata?.plan_name) {
      case "LearnTube Pro":
        {
          dispatch(
            createLeadScore(
              user_id,
              leadScoringActivity.CLICKED_LTPRO_CARD.type,
            ),
          );
          Mixpanel.track(Constants.Mixpanel.CLICKED_LTPRO_CARD, {
            distinct_id: email,
          });
        }
        break;
      case "LearnTube Pro+":
        {
          dispatch(
            createLeadScore(
              user_id,
              leadScoringActivity.CLICKED_LTPROPLUS_CARD.type,
            ),
          );
          Mixpanel.track(Constants.Mixpanel.CLICKED_LTPROPLUS_CARD, {
            distinct_id: email,
          });
        }
        break;
      case "LearnTubeX":
        {
          dispatch(
            createLeadScore(user_id, leadScoringActivity.CLICKED_LTX_CARD.type),
          );
          Mixpanel.track(Constants.Mixpanel.CLICKED_LTX_CARD, {
            distinct_id: email,
          });
        }
        break;
      case "LearnTube Max": {
        dispatch(
          createLeadScore(user_id, leadScoringActivity.CLICKED_LTMAX_CARD.type),
        );
        Mixpanel.track(Constants.Mixpanel.CLICKED_LTMAX_CARD, {
          distinct_id: email,
        });
      }
      default:
        break;
    }
  }

  return (
    <>
      <div
        className={` border-1 relative flex cursor-pointer  flex-col  items-center  justify-center     rounded-lg  border-[#979797]   shadow-lg ${
          isCardEnabled && isSelected ? "text-white" : "text-black"
        } ${
          window.innerWidth <= 370
            ? "mr-1 px-1 py-3"
            : "ml-2 px-2  py-3 md:ml-0  md:mr-0 md:w-[90%]  md:px-4 md:py-4"
        }`}
        onClick={(event) => {
          setIsCardEnabled(id);
          createLeads(cardData);
          setIsSelected(true);
        }}
        ref={scrollRef}
        style={{
          background:
            isCardEnabled && isSelected
              ? `linear-gradient(418deg, ${cardData?.plan_color_primary} 16.15%, ${cardData?.plan_color_secondary} 86.12%)`
              : "white",
        }}
      >
        {cardData?.is_active_plan ? (
          <div className="absolute top-0 right-0 rounded-tr-lg rounded-bl-lg bg-[#54D15A] p-[0.5px] text-supertiny md:p-1 md:text-sm">
            Plan Active
          </div>
        ) : cardData?.plan_name === "LearnTube Max" && user_role === 7 ? (
          <div className="absolute top-0 right-0 rounded-tr-lg rounded-bl-lg bg-[#54D15A] p-[1.5px] text-supertiny md:text-sm">
            Trial Active
          </div>
        ) : cardData?.plan_name === "Downgrade" &&
          user_role === 1 &&
          !isBlocked ? (
          <div className="absolute top-0 right-0 rounded-tr-lg rounded-bl-lg bg-[#54D15A] p-[0.5px] text-supertiny md:p-1 md:text-xs">
            Plan Active
          </div>
        ) : (
          <></>
        )}
        <img
          urlEndpoint="https://img.learntube.ai/public-assets/"
          src={cardData?.plan_image}
          className="h-6 w-6 md:h-7 md:w-7"
        />
        <div className={"whitspace-nowrap mt-1 text-xs font-medium md:text-sm"}>
          {cardData?.plan_name}
        </div>
        <div className="text-xs font-medium md:text-sm">For</div>
        <div className="whitespace-nowrap text-xs font-bold  md:text-[16px]">
          {cardData?.plan_for}
        </div>
      </div>
    </>
  );
};

export default PricingCard;
